import { render, staticRenderFns } from "./CancellationPolicyDescription.vue?vue&type=template&id=c804fa2e&lang=pug&"
import script from "./CancellationPolicyDescription.vue?vue&type=script&lang=ts&"
export * from "./CancellationPolicyDescription.vue?vue&type=script&lang=ts&"
import style0 from "./CancellationPolicyDescription.vue?vue&type=style&index=0&id=c804fa2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports